export const HELPDESK = 'HELPDESK';